import React from "react";
import { useNavigate } from "react-router-dom";
import { Clock, ShieldQuestion } from "lucide-react";

export default function WaitingRoomInfoPage() {
  const navigate = useNavigate();
  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="waiting-room-info-page">
      <div className="w-16 h-16 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mx-auto mb-5">
        <Clock className="w-7 h-7 text-cyan-300" />
      </div>
      <h1 className="font-heading text-2xl font-semibold text-white">Waiting Room</h1>
      <p className="text-sm text-slate-400 mt-2">
        This is a real, working feature — toggle "Enable Waiting Room" when starting a meeting, and every guest will
        wait for your approval before they can enter. Pending requests show up live inside the meeting room while you're hosting.
      </p>
      <button onClick={() => navigate("/meetings/all")} data-testid="waiting-room-info-cta-btn"
        className="mt-6 inline-flex items-center gap-2 bg-cyan-500 hover:bg-cyan-500/90 text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors">
        <ShieldQuestion className="w-4 h-4" /> Start a meeting with Waiting Room
      </button>
    </div>
  );
}
